template
<template>
  <!-- <svg
    width="43"
    height="44"
    viewBox="0 0 43 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.1431 25.6667H3.5835V29.3334H16.1431V34.8334L23.2918 27.5L16.1431 20.1667V25.6667ZM26.8572 23.8334V18.3334H39.4168V14.6667H26.8572V9.16669L19.7085 16.5L26.8572 23.8334Z"
      fill="#595A5B"
      fill-opacity="0.87"
    />
  </svg> -->
  <svg
    width="43"
    height="44"
    viewBox="0 0 43 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.1429 25.6665H3.58331V29.3332H16.1429V34.8332L23.2916 27.4998L16.1429 20.1665V25.6665ZM26.8571 23.8332V18.3332H39.4166V14.6665H26.8571V9.1665L19.7083 16.4998L26.8571 23.8332Z"
      fill="#595A5B"
    />
  </svg>
</template>
